import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { Iconfont } from '../../../../components/icon/iconfont'

export default props => {
    useStyles(classes)
    const { selected, disabled, onClick } = props
    return selected ? <Iconfont onClick={onClick} className={`${classes.CheckBox} ${disabled?classes.Disabled:''}`}>&#xe658;</Iconfont>: <Iconfont onClick={onClick} className={`${classes.CheckBox} ${disabled?classes.Disabled:''}`}>&#xe65a;</Iconfont>
}